<template>
			<div id="content" class="app-content box-shadow-3">

				Assessment Approval Confirmation
			</div>
</template>

<style scoped>
.margin-overlap {
	margin-right: -2.5rem;
}
.button {
  background-color: #4CAF50; /* Green */
  border: none;
  color: white;
  padding: 16px 32px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 4px 2px;
  transition-duration: 0.4s;
  cursor: pointer;
}

.button1 {
  background-color: white; 
  color:  #4CAF50; 
  border: 2px solid #4CAF50;
}

.button1:hover {
  background-color: #4CAF50;
  color: white;
}
</style>

<script>
import EditPane from "@/components/EditPane";
import SaveOptionalModal from "@/components/SaveOptionalModal";
import ConfigSelect from "@/components/ConfigSelect";
import RichText from "@/components/RichText";

import AssessmentService from "@/services/AssessmentService";
import ContentAreaService from "@/services/ContentAreaService";
import GradeService from "@/services/GradeService";
import ValidationService from "@/services/ValidationService";
import Notie from "@/services/NotieService";
import fs from "@/services/FormatService";
import BB from "bluebird";
import Utils from "@/services/Utils";
import draggable from "vuedraggable";
import ConfigItemSearch from "@/components/ConfigItemSearch";

export default {
	name: "AssessmentApprove",

	props: ["id", "assessment", "defaultTab", "valid"],

	components: {
		EditPane,
		SaveOptionalModal,
		ConfigSelect,
		ConfigItemSearch,
		RichText,
		draggable
	},

	data() {
		return {
			fs: fs,
            ntests : 0,
			originalDesc: [],
			refresh: null,

			dirty: false,
			saveOptModal: false,
			saveOptNext: () => {},
			saveOptCancel: () => {}
		};
	},

	computed: {

	},

	created() {
        if(this.assessment.test_responses){
            for(let element of this.assessment.test_responses ){
                this.originalDesc.push(element)
            }
            this.ntests = this.assessment.test.length
        }
        else{
            this.assessment.test = []
            this.ntests = 0
        }


    },

	watch: {
        assessment(newVal){
            console.log("TEST CHANGED ")
        }

	},

	beforeRouteLeave(to, from, next) {
		if (this.dirty) {
			this.saveOptNext = () => {
				next();
			};
			this.saveOptCancel = () => {
				next(false);
			};
			this.saveOptModal = true;
		} else {
			next();
		}
	},

	methods: {
		Initial(index){
			return this.assessment.test_responses[index]
		},
		watchChanges() {
			if (this.unwatch) {
				this.unwatch();
			}
			this.unwatch = this.$watch(
				"assessment",
				(newc, old) => {
					this.dirty = true;
				},
				{ deep: true }
			);
		},


		canSave() {
			return this.dirty;
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/assessment/AssessmentApprove.vue